import { render, staticRenderFns } from "./CancelDeliveryModal.vue?vue&type=template&id=18f26872&"
import script from "./CancelDeliveryModal.vue?vue&type=script&lang=js&"
export * from "./CancelDeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./CancelDeliveryModal.vue?vue&type=style&index=0&id=18f26872&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports